import React, { useState, useEffect } from "react";
import { Outlet, Link, useNavigate, router, useParams } from "react-router-dom";
import { AppValues, API, ApiUrl, PayMoob } from "../Values";
import { useLocation } from "react-router-dom";
import Cookies from "js-cookie";

const PaymentCallBack = () => {
  const navigate = useNavigate();

  var userinfo = [];
  var Username = "";
  var UserID = "";
  if (Cookies.get("userinfo")) {
    userinfo = JSON.parse(Cookies.get("userinfo"));
    Username = userinfo[0].Name;
    UserID = userinfo[0].ID;
  }
  //--------------------------------

  let [number_order, Setnumber_order] = useState("0");
  let [name, Setname] = useState("");
  const [status, setStatus] = useState(null);

  const [transactionStatus, setTransactionStatus] = useState(null);
  const handleCallback = (event) => {
    if (event.origin === "https://accept.paymobsolutions.com") {
      const data = JSON.parse(event.data);
      setTransactionStatus(data);
    }
  };

  useEffect(() => {
    window.addEventListener("message", handleCallback);
    return () => {
      window.removeEventListener("message", handleCallback);
    };
  }, []);

  let [success, Setsuccess] = useState("");
  let [id, Setid] = useState("");
  let [amount_cents, Setamount_cents] = useState("");
  let [integration_id, Setintegration_id] = useState("");
  let [order, Setorder] = useState("");
  let [hmac, Sethmac] = useState("");
  let [amount, Setamount] = useState("500");
  let [currency, Setcurrency] = useState("EG");
  let [created_at, Setcreated_at] = useState("2024-01-01");
  let [data_message, Setdata_message] = useState("");
  const [date_, Setdate] = useState("");
  let location = useLocation();

  useEffect(() => {
    // Extract query parameters from the URL
    let queryParams = new URLSearchParams(location.search);
    Setsuccess(queryParams.get("success"));
    Setid(queryParams.get("id"));
    Setamount_cents(queryParams.get("amount_cents"));
    Setintegration_id(queryParams.get("integration_id"));
    Setorder(queryParams.get("order"));
    Sethmac(queryParams.get("hmac"));
    Setcreated_at(queryParams.get("created_at"));
    Setamount(queryParams.get("amount_cents"));
    Setcurrency(queryParams.get("currency"));
    Setdata_message(queryParams.get("data.message"));
    // Log the details for debugging
    console.log("success :", success);
    console.log("Transaction ID:", integration_id);
    console.log("Order ID:", order);
    console.log("Amount:", amount);
    console.log("hmac:", hmac);
    console.log(queryParams);
    fetchPaymentStatus(queryParams.get("id"));
    const Vesanumber_order = JSON.parse(Cookies.get("Vesanumber_order"));
    Setnumber_order(Vesanumber_order.number_order);
    VesaOrderPaymentOk(queryParams.get("success"));

    // Process the data
    // if (success === "true") {
    // Handle successful payment
    //   alert("Payment Successful!");
    // } else {
    // Handle failed payment
    //   alert("Payment Failed.");
    // }
  }, [location]);

  /*
  id=241119389
  pending=false
  amount_cents=10000
  success=true
  is_auth=false
  is_capture=false
  is_standalone_payment=true
  is_voided=false
  is_refunded=false
  is_3d_secure=true
  integration_id=4891042
  profile_id=1009769
  has_parent_transaction=false
  order=270912332
  created_at=2024-12-03T12%3A53%3A38.148230
  currency=EGP
  merchant_commission=0
  discount_details=%5B%5D
  is_void=false
  is_refund=false
  error_occured=false
  refunded_amount_cents=0
  captured_amount=0
  updated_at=2024-12-03T12%3A53%3A57.921880
  is_settled=false
  bill_balanced=false
  is_bill=false
  owner=1877825
  data.message=Approved
  source_data.type=card
  source_data.pan=2346
  source_data.sub_type=MasterCard
  acq_response_code=00
  txn_response_code=APPROVED
  hmac=b264b381342cb43fe2e1d054628a7637e97637b2b0f5b15bf20fcec8f4cefb31c520735254816f38e09f8ddb5dd23cd67de2590b031285492db91aa7d1d4afc0
*/
  useEffect(() => {
    const dateObj = new Date(created_at);
    const formattedDate =
      dateObj.getFullYear() +
      "-" +
      String(dateObj.getMonth() + 1).padStart(2, "0") +
      "-" +
      String(dateObj.getDate()).padStart(2, "0");

    // تنسيق الوقت: HH:mm:ss
    const formattedTime =
      String(dateObj.getHours()).padStart(2, "0") +
      ":" +
      String(dateObj.getMinutes()).padStart(2, "0") +
      ":" +
      String(dateObj.getSeconds()).padStart(2, "0");

    Setdate(`${formattedDate}  - ${formattedTime}`);
  }, [created_at]);

  async function VesaOrderPaymentOk(success_) {
    const Vesanumber_order = JSON.parse(Cookies.get("Vesanumber_order"));
    console.log(success_);

    try {
      if (success_ == "true") {
        if (Vesanumber_order.type == "AddRasseMandowb") {
          JSON.parse(Cookies.get("userinfo"));
          const userinfo = JSON.parse(Cookies.get("userinfo"));
          const Mony = Cookies.get("VesaAmount");
          const post = {
            Action: "AddRasseMandowb",
            Mony: Mony,
            Name: userinfo[0].Name,
            ID: userinfo[0].ID,
            $account_type: "مندوب",
          };
          const respons = await fetch(`${ApiUrl}/Deller/CalculateData.php`, {
            method: "POST",
            body: JSON.stringify(post),
          });
          const data_ = await respons.json();
          console.log(data_);
        }
        //=================================
        if (Vesanumber_order.type == "sdadOrder") {
          console.log("number_order" + Vesanumber_order.number_order);
          const post = {
            Action: "VesaOrderPaymentOk",
            number_order: Vesanumber_order.number_order,
          };
          const response = await fetch(API.Orders, {
            method: "POST",
            body: JSON.stringify(post),
          });
          const data_ = await response.json();
          console.log(data_);
        }

        Cookies.remove("VesaAmount");
        Cookies.remove("Vesanumber_order");
      }
    } catch (error) {
      return error;
    }
  }
  async function fetchPaymentStatus(paymentId) {
    const response = await fetch(
      `https://api.baymonb.com/check-payment-status`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${PayMoob.api_key}`,
        },
        body: JSON.stringify({
          paymentId: paymentId,
        }),
      }
    );

    const data = await response.json();
    console.log(data);
    if (data.status === "success") {
      setStatus("success");
    } else {
      setStatus("Failed");
    }
  }
  return (
    <>
      <div
        dir="rtl"
        className="row mt-0 text-center0 m-auto bg-white "
        style={{ maxWidth: "600px",height:"100vh" }}
      >
        <div className="col-1 py-1 bg-light0 ">
          <i
            className="fa-solid fa-chevron-right px-1 mt-2 fs-4 "
            onClick={() => navigate("../Login")}
          ></i>
        </div>
        <div className="col-11 py-1 text-center  bg-light0">
          <h4> Transaction Status </h4>
        </div>
        <br />

        {success == "true" && <PaySuccess />}
        {success != "true" && <PayFiald />}
        <div className="col-12 text-center pt-4 mt-4">
          <img src="../../logo.png" alt="logo" style={{ width: "100px" }} />
        </div>
      </div>
    </>
  );

  function PaySuccess() {
    return (
      <div className="col-12 text-center mt-2 pt-2">
        {/* <h2 className="fw-bold  text-center my-1 stc fw-bold text-green">
          {"Success "}
        </h2>  */}
        <img
          src="./success.jpg"
          alt="success_"
          className="my-4"
          style={{ width: "180px" }}
        />
        {/* <i
          className="fa-solid fa-circle-check text-green my-4"
          style={{ fontSize: "80px" }}
        ></i> */}

        <h4 className="fw-bold  text-center my-2 stc"> تمت العملية بنجاح </h4>

        {/* {Vesanumber_order.type == "sdadOrder" && <span>{number_order}</span>} */}

        <h1 dir="ltr">
          {parseFloat(amount / 100)}
          <span className="px-1 text-orange">{currency}</span>
        </h1>
        <h6 className="text-secondary stc my-4"> اجمالى المبلغ المحول </h6>
        <label className="text-secondary0 stc my-2 text-center w-100">
          {"  رقم العملية : "}
          <span dir="rtl">{id}</span>
        </label>
        <label className="text-secondary0 stc my-2  text-center w-100">
          التاريخ : <span dir="rtl">{date_}</span>
        </label>
      </div>
    );
  }

  function PayFiald() {
    return (
      <div className="col-12 text-center mt-4 pt-4">
        <img
          src="./fiald.jpg"
          alt="fiald"
          className="my-4"
          style={{ width: "180px" }}
        />

        {/* <i
          className="fa-solid fa-xmark text-danger"
          style={{ fontSize: "100px" }}
        ></i> */}

        <h4 className="fw-bold  text-center my-3 stc"> العملية فاشلة </h4>
        <h6 className=" text-center mt-2 mb-4"> {data_message}</h6>

        <h1 dir="ltr">
          {parseFloat(amount / 100)}
          <span className="px-1 text-orange">{currency}</span>
        </h1>
        <h6 className="text-secondary stc"> اجمالى المبلغ المحول </h6>
        <label className="text-secondary0 stc text-center w-100  my-4">
          {"  رقم العملية : "}
          <span dir="rtl">{id}</span>
        </label>
        <label className="text-secondary0 stc text-center w-100 mb-2">
          التاريخ :  <span dir="rtl">{date_}</span>
        </label>
        <br />
        <label className="text-secondary0 stc text-center w-100  my-4">
          {"الرقم المرجعى : "}
          <span dir="rtl">{integration_id}</span>
        </label>
        {/* <label className="text-secondary0 stc text-center w-100  my-4">
          {" رقم اوردر : "}
          <span dir="rtl">{order}</span>
        </label> */}


      </div>
    );
  }
};
export default PaymentCallBack;
